import {TRANSACTION_CATEGORIES} from "../../shared/Constants";

export const getTransactionName = (id) => {
   return TRANSACTION_CATEGORIES.find(item => item.id === +id)?.name ?? '-'
}